import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
    
    
}


// WEBPACK FOOTER //
// ./www/js/Components/Modal/Modal.ts